import { render, staticRenderFns } from "./DvPropsDatasource.vue?vue&type=template&id=c325beb8&scoped=true"
import script from "./DvPropsDatasource.vue?vue&type=script&lang=js"
export * from "./DvPropsDatasource.vue?vue&type=script&lang=js"
import style0 from "./DvPropsDatasource.vue?vue&type=style&index=0&id=c325beb8&prod&lang=less"
import style1 from "./DvPropsDatasource.vue?vue&type=style&index=1&id=c325beb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c325beb8",
  null
  
)

export default component.exports